export const containsNoCase = (str: string, test: string): boolean => {
  if (!str) return false;
  if (!test) return true;
  return str.toLowerCase().includes(test.toLowerCase());
};
export const containsNoCaseNoLocale = (str: string, test: string): boolean => {
  if (!str) return false;
  if (!test) return true;
  return str.toLocaleLowerCase().includes(test.toLocaleLowerCase());
};

export const parseIntOrNull = (s: string): number => {
  if (s === null || s === undefined) return null;
  const val = Number(s);
  return Number.isNaN(val) ? null : val;
};

// SOURCE: https://stackoverflow.com/a/9310752/3353146
export function escapeRegExp(text) {
  return text?.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&') ?? text;
}

export function makeRegexOptions(config: { highlightAll: boolean; caseSensitive: boolean }) {
  const { highlightAll, caseSensitive } = config;
  return `${highlightAll ? 'g' : ''}${!caseSensitive ? 'i' : ''}`;
}

export const buildMultiTermSearchQuery = (searchQuery: string): string => {
  if (!searchQuery) {
    return '';
  }

  const terms = searchQuery.trim().split(' ');

  return `${terms
    .map(x => x.trim())
    .filter(x => !!x)
    .map(x => `+${x}`)
    .join(' ')
    .trim()}*`;
};
